import React from 'react';
import { Grid } from '@mui/material';

import { AuthorizerContext } from 'app/providers/acl/AclProvider';
import { SimpleTextField, useSettings, SearchSelectField } from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function UsersDetailsSectionConnectors(props: DetailsSectionInfoContentProps) {
	const { sysSettings, t } = useSettings();
	const authorizer = React.useContext(AuthorizerContext);

	const systemInfoAuthorized = authorizer.can('update', 'users');

	const isRevisoIntegrationActive = sysSettings.billing_reviso_integration === 'true';

	return (
		<>
			{/* ERP ID */}
			<Grid size={12}>
				<SimpleTextField
					name="user_erp_id"
					label={t('DETAILS_USERS_FIELD_ERP_ID')}
					value={props.model.user_erp_id}
					isEdit={props.isEdit && systemInfoAuthorized}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* MES ID */}
			<Grid size={12}>
				<SimpleTextField
					name="user_mes_id"
					label={t('DETAILS_USERS_FIELD_MES_ID')}
					value={props.model.user_mes_id}
					isEdit={props.isEdit && systemInfoAuthorized}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* PUNCH CLOCK BARCODE */}
			<Grid size={12}>
				<SimpleTextField
					name="user_punchclock_barcode"
					label={t('DETAILS_USERS_FIELD_PUNCH_CLOCK_BARCODE')}
					value={props.model.user_punchclock_barcode}
					isEdit={props.isEdit && systemInfoAuthorized}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* REVISO PRODUCT */}
			{/* {isRevisoIntegrationActive && (
				<Grid item xs={12}>
					<SearchSelectField
						name="user_reviso_product_id"
						label={t('DETAILS_USERS_FIELD_REVISO_PRODUCT_ID')}
						systable="reviso_products"
						value={props.model.user_reviso_product_id}
						getOptionLabel={option => `${option.rprd_erp_id} - ${option.rprd_title}`}
						isEdit={props.isEdit}
						sendChange={props.sendChange}
						logProps={props.logProps}
					/>
				</Grid>
			)} */}
		</>
	);
}
